import { shallowRef, type ShallowRef } from 'vue';

/**
 * Chromium `beforeinstallprompt` can fire before any Vue component mounts.
 * Register once at app entry (imported from `main.ts`) so the event is never missed.
 */
export interface BeforeInstallPromptEvent extends Event {
  prompt: () => Promise<void>;
  userChoice: Promise<{ outcome: 'accepted' | 'dismissed' }>;
}

const deferredBeforeInstallPrompt: ShallowRef<BeforeInstallPromptEvent | null> = shallowRef(null);

function onBeforeInstallPrompt(e: Event): void {
  e.preventDefault();
  deferredBeforeInstallPrompt.value = e as BeforeInstallPromptEvent;
}

window.addEventListener('beforeinstallprompt', onBeforeInstallPrompt);

export function getDeferredBeforeInstallPrompt(): ShallowRef<BeforeInstallPromptEvent | null> {
  return deferredBeforeInstallPrompt;
}

export function clearDeferredBeforeInstallPrompt(): void {
  deferredBeforeInstallPrompt.value = null;
}
